import { render, staticRenderFns } from "./chapterDetail.vue?vue&type=template&id=bd6bf02e&scoped=true&"
import script from "./chapterDetail.vue?vue&type=script&lang=js&"
export * from "./chapterDetail.vue?vue&type=script&lang=js&"
import style0 from "./chapterDetail.vue?vue&type=style&index=0&id=bd6bf02e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6bf02e",
  null
  
)

export default component.exports